<template>
  <app-dropdown
      :options="mappedPumps"
      :value="pumpId"
      @change="handleInput"
  ></app-dropdown>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Dropdown from "../../input/Dropdown";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: 'PumpDropdown',

  components: {
    'app-dropdown': Dropdown
  },

  mixins: [googleAnalyticsMixin],

  computed: {
    ...mapState({
      pumpId: state => state.build.pump,
    }),
    ...mapGetters({
      motorOption: 'preference/getMotorOption',
      pumps: 'pumps/getPumps',
      best: 'build/getBestPump',
      availablePumps: 'pumps/getAvailablePumps'
    }),

    mappedPumps() {
      return this.availablePumps
          .map(pump => {
            return {
              key: pump.id,
              value:
                pump.pump_group !== null && pump.pump_group.name !== null
                  ? pump.cc + ' (' + this.translate(pump.pump_group.name) + ')'
                  : pump.cc,
              recommended: this.best === pump.id
            }
          });
    }
  },

  methods: {
    handleInput(id) {
      this.pushDataLayer({
        step: this.gaData.steps.step4,
        interaction_type: this.gaData.interactionTypes.click,
        field: 'slagvolume pomp',
        value: this.gaData.undefined,
        build_id: this.gaData.undefined
      })

      this.$store.dispatch('build/setPump', id);
      this.$store.dispatch('build/setBestTank')
    }
  }
}
</script>
